exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu{max-height:70vh!important;overflow:auto!important}", ""]);

// exports
